// frontend/src/components/Samples/LineAttachmentsModal.jsx

import React from 'react';
import { FiX, FiPaperclip } from 'react-icons/fi';
import FileUpload from '../Common/FileUpload';
import { useTranslation } from '../../context/TranslationContext';
import '../Settings/Modal.css';

const LineAttachmentsModal = ({
  line,
  entityType = 'sample_order_line',
  onClose,
  pendingMode = false,
  pendingFiles = [],
  onPendingFilesChange,
}) => {
  const { t } = useTranslation();

  const lineLabel = [
    line.enteredProductCode || line.entered_product_code,
    line.enteredProductColor || line.entered_product_color,
    line.lineDescription || line.line_description,
  ].filter(Boolean).join(' — ') || `${t('sample_orders.line', 'Linha')} ${line.matrixLineNo ?? ''}`;

  const entityId = pendingMode ? null : (line.sample_order_line_id || null);

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-content" style={{ maxWidth: 820 }}>

        {/* Header */}
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <FiPaperclip size={18} style={{ color: 'var(--primary)', flexShrink: 0 }} />
            <div>
              <h3 style={{ margin: 0 }}>{t('attachments.line', 'Anexos da Linha')}</h3>
              {lineLabel && (
                <p style={{ margin: '3px 0 0', fontSize: 13, color: 'var(--gray-500)' }}>
                  {lineLabel}
                </p>
              )}
            </div>
          </div>
          <button type="button" onClick={onClose} className="modal-close">
            <FiX size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="modal-body">
          {pendingMode && (
            <div style={{
              padding: '10px 14px',
              background: '#fffbeb',
              border: '1px solid #fde68a',
              borderRadius: 8,
              fontSize: 13,
              color: '#92400e',
              marginBottom: 16,
            }}>
              ⚠️ {t('attachments.will_upload_on_save',
                'Estes ficheiros serão guardados quando guardar o pedido de amostra.')}
            </div>
          )}

          <FileUpload
            entityType={entityType}
            entityId={entityId}
            maxFiles={20}
            sideBySide={true}
            pendingMode={pendingMode}
            pendingFiles={pendingFiles}
            onPendingFilesChange={onPendingFilesChange}
            label=""
          />
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <button type="button" onClick={onClose} className="btn-secondary">
            {t('close', 'Fechar')}
          </button>
        </div>

      </div>
    </div>
  );
};

export default LineAttachmentsModal;